import type { ReactNode } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogAction } from "@repo/ui";
import type { TaskManagerDTO } from "~/types/api-custom";
import { ChangeStatusForm } from "./change-status-form";

type Props = {
  task: TaskManagerDTO;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  trigger?: ReactNode;
};

export const ChangeStatusDialog = ({ task, isOpen, onOpenChange, trigger }: Props) => (
  <Dialog open={isOpen} onOpenChange={onOpenChange}>
    {trigger && <DialogAction openState={true}>{trigger}</DialogAction>}
    <DialogContent className="w-[500px]">
      <DialogHeader>
        <DialogTitle>Change Task Status</DialogTitle>
      </DialogHeader>
      <ChangeStatusForm task={task} onClose={() => onOpenChange(false)} />
    </DialogContent>
  </Dialog>
);
